<template>
  <div class="w-full space-y-2" v-if="shouldDisplayContent">
    <div class="w-full flex">
      <BaseSkeleton v-if="props.loading" class="w-24 h-5 flex-none rounded" />
      <div
        v-else-if="shouldDisplaySentiment"
        class="h-5 flex-none rounded overflow-hidden text-xs px-2 flex items-center"
        :class="sentimentsList(sentimentIndex).tokenClass"
      >
        {{ $t(`genius.context.${props.sentiment}`) }}
      </div>
    </div>
    <div v-if="props.loading" class="text-xs mayday-animate-wave">
      {{ $t('genius.context.loading') }}
    </div>
    <BaseEditor
      v-else-if="shouldDisplayContext"
      ref="editorRef"
      class="w-full text-caption text-sm"
      :options="editorOptions"
      size="sm"
      :editable="false"
    />
  </div>
</template>
<script setup lang="ts">
import { sentimentsList } from '../../utils/sentimentsList';

const props = defineProps<{
  context?: string;
  sentiment?: number;
  loading?: boolean;
  displaySentiment?: boolean;
  displayContext?: boolean;
}>();

const editorOptions = ref({
  streamingOptions: true,
  allowToneImprovement: true,
  fontOptions: true,
  structurationOptions: true,
  tableOptions: true,
  richOptions: true,
  extraStructurationOptions: true,
  extraFontOptions: true,
  tocClickOptions: true,
  allowToc: true,
  colorOptions: true,
  hideDragHandle: false,
  hideInlineToModal: false,
});

const editorRef = ref<any | null>(null);
const MdStreamer = ref<any | null>(null);

const shouldDisplayContent = computed(() => {
  return (
    shouldDisplayContext.value || shouldDisplaySentiment.value || props.loading
  );
});

const shouldDisplayContext = computed(() => {
  return props.context?.length && props.displayContext;
});

const shouldDisplaySentiment = computed(() => {
  return props.sentiment !== undefined && props.displaySentiment;
});

const sentimentIndex = computed(() => {
  return props.sentiment ? props.sentiment - 1 : 0;
});

watch(
  () => [props.context, editorRef.value],
  () => {
    if (!props.context || !editorRef.value) return;
    MdStreamer.value = editorRef.value.createStreamer('md');
    nextTick(() => {
      editorRef.value?.clearContent();
      MdStreamer.value.handleChunk(props.context);
    });
  },
  { deep: true, immediate: true },
);
</script>
<style scoped>
.mayday-animate-wave {
  animation: wave 1.5s infinite ease-in-out !important;
}
@keyframes wave {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}
</style>
